import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  message:
    'Do you want to save changes made to these Settings? Your changes will be lost if you don’t save them.',
  title: 'Unsaved Changes',
})
